import React, { Component } from 'react';
import Bundle from '../Common/Bundle';
import { truncate as lodashTruncate } from 'lodash';
import { getStoreCode } from '../Store/Store.APP_ENV.js';

export const lazify = (WrappedComp) => {
  return class LazyloadStaticPage extends Component {
    render() {
      return (
          <Bundle load={WrappedComp}>
            {Comp => (Comp
              ? <Comp {...this.props}/>
              : null
            )}
          </Bundle>
      );
    }
  };
};

export const roundCurrency = (value) => {
  return round(value, 2);
};

export const signedCurrency = (value) => {
  const currency = roundCurrency(value);

  return currency >= 0 ? `+${currency}` : currency;
}

export const formatSignedCurrency = (value, format) => {
  let price = value;
  if (typeof value === 'string') { // some prices are in string
    price = parseFloat(price);
  }

  let result = roundCurrency(price); // default if null format
  if (format) { 
    price = Math.round(price);
    result = `${format.currency_symbol} ${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, format.thousand_separator)}`;
  }
  
  return result;
}

export const round = (value, exp) => {
  if (typeof exp === 'undefined' || +exp === 0)
    return Math.round(value);

  value = +value;
  exp = +exp;

  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
    return NaN;

  // Shift
  value = value.toString().split('e');
  value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

  // Shift back
  value = value.toString().split('e');
  value = +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));

  //Adding zero
  value = value.toString();
  if(value.indexOf('.') == -1)
    value += '.';
  while (value.length <= value.indexOf('.') + exp )
    value += '0';

  return value;
};

// responsive body text
export const resBody = (v) => {
  return <p className='responsive-content-body'>{v}</p>
};

// responsive title text
export const resTitle = (v) => {
  return <p className='responsive-content-title'>{v}</p>
};

export const titlelize = (string) => {
  return string
    .replace(/([A-Z])/g, ' $1')
    .replace(/_|-/g, ' ')
    .replace(/^.|\s./g, str => str.toUpperCase())
    .trim();
}

// mega menu block sizing used only for dynamic image and text
export const menuBlockResize = (height, rowSize) => {
  if (height) {
    return height;
  }

  switch (rowSize) {
    case 1:
      return '200px';
    case 2:
      return '400px';
    case 3:
      return '600px';
    default:
      return '200px';
  }
}

export const forDesktopOnly = (WrappedComponent) => {
  return class ForDesktopOnly extends Component {
    render() {
      return (
        <span className='d-none d-lg-block'>
          <WrappedComponent {...this.props}/>
        </span>
      );
    }
  }
};

export const getTaopixUrl = (url) => {
  const storeDomain = /^www\./.test(url) ? url.substring(4) : url;

  return `https://store.${storeDomain}`;
};

export const forMobileOnly = WrappedComponent => props =>
  <span className='d-lg-none'>
    <WrappedComponent {...props}/>
  </span>

export const scriptExists = url =>
  document.querySelectorAll(`script[src="${url}"]`).length > 0

export const transpose = a =>
  a && a.length && a[0].map && a[0].map(function (_, c) { return a.map(function (r) { return r[c]; }); }) || [];

export const isObjectEmpty = obj =>
  Object.keys(obj).length === 0;

export const createStringFromTemplate = (template, variables) =>
  template.replace(new RegExp("\{([^\{]+)\}", "g"), (_unused, varName) =>
    variables[varName] || ''
  );

export const fromCamelToSnakeCase = (str = '') =>
  str.replace(/([A-Z])/g, $1 => `_${$1.toLowerCase()}`);

export const toTitleCase = str => 
 str.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }); 

export const objectKeysFromCamelToSnakeCase = inObject =>
  Object.keys(inObject).reduce((obj, key) => {
    const newKey = fromCamelToSnakeCase(key);
    return {
      ...obj,
      [newKey]: inObject[key]
    };
  }, {});

export const truncate = (name, MAX_LENGTH = 80) => {
  if (name.length > MAX_LENGTH) {
    return name.substring(0, MAX_LENGTH) + '...';
  }
  return name;
};

export const addMetaTagToHead = ({ name, content }) => {
  const meta = document.createElement('meta');
  meta.name = name;
  meta.setAttribute('content', content);
  document.getElementsByTagName('head')[0].appendChild(meta);
};

export const addMetaOgTagToHead = ({ property, content }) => {
  const meta = document.createElement('meta');
  meta.setAttribute('property', property);
  meta.setAttribute('content', content);
  document.getElementsByTagName('head')[0].appendChild(meta);
};

export const removeMetaTag = (metaName) => {
  document.querySelectorAll(`meta[name="${metaName}"]`).forEach(tag => tag.remove());
};

export const removeUnicodeControlCharacters = (value) => {
  return value.replace(/[\x01-\x1F\x7F]+/g, '');
};

export const shortenText = (text, length, omission) => lodashTruncate(text, { length: length, omission: omission });

export const localiseAmount = (amount) => {
  switch (getStoreCode()){
    case 'PBVN':
      return new Intl.NumberFormat('vn-VN').format(amount);
    default:
      return amount;
  }
}



// WEBPACK FOOTER //
// ./src/Common/Helper.js